import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'careers/i18n'
import { logEvent, EVENT_ACTIONS } from 'actions/audit-trail'
import ThirdPartyScripts from 'careers/components/third-party-scripts'
import { Flex } from 'components/styled/containers/flex'
import { Body, H3 } from 'components/styled/typography'
import { PageContent } from 'components/styled/page/page-content'
import { I18nComponentType } from 'careers/i18n-types'

interface JobAdSeeYouProps {
  company: { _id: string }
  i18n: I18nComponentType
  dispatch: any
}

const mapStateToProps = (state: any) => ({
  company: state.careers.company,
})

/**
 * Render instructions for user when application saved for later
 * @param {object} i18n
 */
export function JobAdSeeYou({ company, i18n, dispatch }: JobAdSeeYouProps) {
  useEffect(() => {
    dispatch(
      logEvent({
        ec: company._id,
        ea: EVENT_ACTIONS.jobAdSeeYouView,
      })
    )
  }, [])

  return (
    <PageContent size="small">
      <Flex alignItems="flex-start" mt="s48" flexDirection="column">
        <H3 mb="s16">{i18n.jobAdSeeYou.title}</H3>
        <Body>{i18n.jobAdSeeYou.description}</Body>
        <ThirdPartyScripts />
      </Flex>
    </PageContent>
  )
}

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  JobAdSeeYou
)
